import React from "react";
import classes from "./style.module.css";
import Checkbox from "@mui/material/Checkbox";
import { FaGripLines } from "react-icons/fa";

export default function MatchTestElement({
  index,
  text,
  selected,
  handleChange,
  handleClick,
  type,
  id,
  wrong,
}) {
  let colors = [classes.blue, classes.green, classes.yellow, classes.red];
  let colorClasses = [
    classes.testElement,
    colors[index < 4 ? index : index % 4],
  ];
  let leftSide = null;
  if (type === "test") {
    leftSide = (
      <Checkbox
        checked={selected}
        onChange={(e) => handleChange(e.target.checked)}
        sx={{
          padding: 0,
          color: "#fff",
          "&.Mui-checked": {
            color: "#fff",
          },
        }}
      />
    );
  } else if (type === "order") {
    leftSide = <FaGripLines color="#fff" />;
  }

  return (
    <div
      id={id}
      className={colorClasses.join(" ")}
      onClick={() => {
        if (wrong) {
          return;
        } else {
          handleClick(!selected);
        }
      }}
      style={{ opacity: wrong ? 0.5 : 1 }}
    >
      <p>{text}</p>
      {leftSide}
    </div>
  );
}
